import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth-context";

/**
 * Landing page for the magic-link login.
 *
 * This used to read `?token=<jwt>` off the URL and write it to a JS cookie. Under cookie
 * auth that is impossible — an httpOnly cookie can only be set by the server — and the
 * backend now establishes the session before redirecting here. So there is nothing to
 * read: just confirm the session exists and move on.
 *
 * If the redirect still carries a `token` param we deliberately ignore it; it should be
 * dropped backend-side, since a JWT in a URL lands in browser history, `Referer`, and any
 * analytics that record page URLs.
 */
const VerifyMail = () => {
  const { authenticate } = useAuth();
  const location = useLocation();
  const { state } = location;
  const { from = "/dashboard" } = state || {};
  const navigate = useNavigate();

  useEffect(() => {
    authenticate()
      .then(() => navigate(from))
      .catch(() => navigate("/login"));
  }, [authenticate, from, navigate]);

  return <div>VerifyMail</div>;
};

export default VerifyMail;
